<!-- 草莓生长阶段 -->
<template>
  <div style="display: flex">
    <div v-for="pha in phases" :key="pha.seq" :class="`phase step${pha.state}`">
      {{ pha.seq }}、
      {{ pha.name }}
    </div>
    <!-- 
      育苗期
      定植期
      缓苗成活期
      苗生长期
      现蕾开花期
      第一茬果采收期
      盛果采收期
     -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      phases: [
        {
          seq: 1,
          name: '育苗期',
          state: 2,
        },
        {
          seq: 2,
          name: '定植期',
          state: 2,
        },
        {
          seq: 3,
          name: '缓苗成活期',
          state: 2,
        },
        {
          seq: 4,
          name: '苗生长期',
          state: 2,
        },
        {
          seq: 5,
          name: '现蕾开花期',
          state: 2,
        },
        {
          seq: 6,
          name: '第一茬果采收期',
          state: 1,
        },
        {
          seq: 7,
          name: '盛果采收期',
          state: 0,
        },
      ],
    }
  },
}
</script>
<style scoped>
.phase {
  flex-grow: 1;
  font-size: 12px;
  line-height: 28px;
  border-left: solid 1px #cfcfcf;
  padding-left: 10px;
  border-top-left-radius: 2px;
  border-start-end-radius: 2px;
}
.step2 {
  background-color: #afafaf;
  color: #666;
}
.step1 {
  background-color: #499f59;
  color: #cfffcf;
}
.step0 {
  background-color: #4f735f;
  color: #0f3313;
}
</style>


// WEBPACK FOOTER //
// src/components/disease/phase.vue